'use client';

import { getMeta } from "@/utils/http";
import { useQuery } from "@tanstack/react-query";
import { createContext, useEffect, useState } from "react";

const ScreenContext = createContext({
    screenWidth: null,
    isCompactDevice: false,
    organizerHeaderDetail: null,
    setOrganizerHeaderDetail: () => {},
    openPlanner: () => {},
    plannerSidebar: false,
    setPlannerSidebar: () => {}
});

function createInsertElement(elements_string) {
    var div = document.createElement('div');
    div.innerHTML = elements_string.trim();

    return div.children;
}

export function ScreenContextProvider(props) {
    const [screenWidth, setScreenWidth] = useState(undefined);
    const [isCompactDevice, setIsCompactDevice] = useState(false);
    const [organizerHeaderDetail, setOrganizerHeaderDetail] = useState(null);
    const [plannerSidebar, setPlannerSidebar] = useState(false);

    const { data: meta } = useQuery({
        queryKey: ['meta'],
        queryFn: () => getMeta({type: "", params: {}}),
        refetchOnWindowFocus: false
    });

    useEffect(() => {
        if(meta?.meta?.head) {
            let created_elements = createInsertElement(meta?.meta?.head);
            if(created_elements && created_elements.length > 0) {
                for (var c = 0; c < created_elements.length; c++) document.head.appendChild(created_elements[c]);
            }
        }
    }, [meta])

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
            setIsCompactDevice(window.matchMedia("(pointer: coarse)").matches);
        };
    
        handleResize();
        window.addEventListener('resize', handleResize);
    
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const openPlanner = () => {
        setPlannerSidebar(true);
    }

    const context = {
        screenWidth: screenWidth,
        isCompactDevice: isCompactDevice,
        organizerHeaderDetail: organizerHeaderDetail,
        setOrganizerHeaderDetail: setOrganizerHeaderDetail,
        plannerSidebar: plannerSidebar,
        setPlannerSidebar, setPlannerSidebar,
        openPlanner: openPlanner
    }

    return <ScreenContext.Provider value={context}>
        {props.children}
    </ScreenContext.Provider>
}

export default ScreenContext;